import styles from "@styles/pages/cdp/segmentations.module.scss";

import { useEffect, useState } from "react";
import { Segments } from "./Segments";

export const Segmentations = ({
  allSegments,
  selected_segments,
  appliedSegments,
  onSelectSegments,
  onClearSegments,
  search,
}) => {
  const [segments, setSegments] = useState(allSegments);
  const [filteredSegments, setFilteredSegments] = useState(allSegments);
  const [selectedSegments, setSelectedSegments] = useState(selected_segments);

  useEffect(() => {
    setSegments(allSegments);
    setFilteredSegments(allSegments);
  }, [allSegments]);

  useEffect(() => {
    setSelectedSegments(selected_segments);
  }, [selected_segments]);

  useEffect(() => {
    if (search && segments) {
      const filtered = filterSegmentsByName(segments, search);
      setFilteredSegments(filtered);
    } else setFilteredSegments(segments);
  }, [search, segments]);

  if (!allSegments) return null;

  const filterSegmentsByName = (data, searchName) => {
    const filteredData = {};

    Object.entries(data).forEach(([key, value]) => {
      const isMainNameMatch = value.name
        .toLowerCase()
        .includes(searchName.toLowerCase());

      const filteredOptions = (value.options || []).filter((option) =>
        option.name.toLowerCase().includes(searchName.toLowerCase())
      );

      if (isMainNameMatch || filteredOptions.length > 0) {
        filteredData[key] = {
          ...value,
          options: filteredOptions,
        };
      }
    });

    return filteredData;
  };

  const selectSegments = (group, modifier, value) => {
    const segmentsCopy = { ...selectedSegments };

    segmentsCopy[group.id] = segmentsCopy[group.id] || [];

    if (value) {
      const index = segmentsCopy[group.id]?.options?.findIndex(
        (option) => option.id === value.id
      );

      if (index !== -1 && segmentsCopy[group.id]?.options) {
        segmentsCopy[group.id]?.options?.splice(index, 1);
      } else {
        segmentsCopy[group.id] = {
          ...segmentsCopy[group.id],
          name: group.name,
          options: segmentsCopy[group.id].options
            ? [...segmentsCopy[group.id].options, value]
            : [value],
        };
      }
    }

    if (modifier) {
      segmentsCopy[group.id].modifier = {
        id: modifier.id,
        name: modifier.name,
      };
    }

    setSelectedSegments(segmentsCopy);
    onSelectSegments(segmentsCopy);
  };

  return (
    <div className={styles.segmentationsContainer}>
      <Segments
        categories={filteredSegments}
        segments={selectedSegments}
        appliedSegments={appliedSegments}
        onSelectSegments={(group, modifier, value) => {
          selectSegments(group, modifier, value);
        }}
        onChangeModifier={(category, modifier) => {
          const segmentsCopy = { ...segments };
          segmentsCopy[category.id].modifier = modifier;

          selectSegments(category, modifier);
        }}
        onConfirmSegments={(newSegments, category, modifier) => {
          setSegments((segments) => {
            return {
              ...segments,
              [category.id]: {
                ...segments[category.id],
                modifier: modifier,
              },
            };
          });
          onSelectSegments(newSegments);
        }}
        onClearSegments={(segment) => onClearSegments(segment)}
      />
    </div>
  );
};
